import React, { FC } from "react";
import { Typography } from "antd";
import "./tableTitle.scss";

interface Props {
  tableName: string;
}

export const TableTitle: FC<Props> = ({ tableName }) => {
  const { Title } = Typography;

  return (
    <>
      <header>
        <Title level={4} className="title-top-space">
          {tableName}
        </Title>
      </header>
    </>
  );
};
